import { render, staticRenderFns } from "./messageBox.vue?vue&type=template&id=b814fd26&"
import script from "./messageBox.vue?vue&type=script&lang=js&"
export * from "./messageBox.vue?vue&type=script&lang=js&"
import style0 from "./messageBox.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports